import { IFacultyQuickLinks } from "../../../../models/dashboard/facultyDashboard";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setQuickLinksWidget } from "../../../../store/slices/master/widgetSlice";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { useNavigate } from "react-router-dom";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const FacultyQuickLinks = (props: IFacultyQuickLinks) => {
  const { snapShots, getQuickLinks, quickLinks } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(ROUTER_URL.FACULTY_ALL_QUICK_LINKS);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.facultyQuickLinks
  );

  useEffect(() => {
    dispatch(setQuickLinksWidget([]));
    if (pageBlockData?.displayOrNot) {
      getQuickLinks(pageBlockId.facultyQuickLinks, limit.two);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setQuickLinksWidget([]));
    };
  }, []);

  return (
    <div
      className={
        pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
      }
      style={
        pageBlockData?.displayOrNot === false
          ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
          : {}
      }
    >
      <div className="title">
        <h2>Quick Links</h2>
        <a
          className={
            pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
          }
          title="View All"
          onClick={handleViewALL}
        >
          View All
        </a>
      </div>
      <div className="row">
        {quickLinks
          ?.filter((link) => link.displayOrNot)
          .map((link) => (
            <div className="col-lg-12" key={link.id || link.name}>
              <div
                className="card reportcard mb-3"
                onClick={() =>
                  window.open(link.url, "_blank", "noopener,noreferrer")
                }
                style={{ cursor: "pointer" }}
              >
                <div className="widget-card">
                  <div className="desc">
                    <h3>{link.name}</h3>
                    <p className="para-hide-1">{link.description}</p>
                    <a className="btn-arrow">
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt="arrow"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getQuickLinks: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId,undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    quickLinks: state.widget.quickLinkWidget,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyQuickLinks);
